import React from 'react'
import PropTypes from 'prop-types'
import Loading from 'components/Loading'

import Content from 'components/ContentDetail'
import Breadcrumb from 'components/Breadcrumb'
import ReactPaginate from 'react-paginate'

import Item from './Item'
import ItemServiceCard from './ItemServiceCard'
import ItemProject from './ItemProject'
import SortCreatedServiceCard from './SortCreatedServiceCard'
import SortUpdatedServiceCard from './SortUpdatedServiceCard'
import SortCreatedProjects from './SortCreatedProjects'
import SortUpdatedProjects from './SortUpdatedProjects'
import FilterProjectStatus from './FilterProjectStatus'
import FinanceProfileSection from './FinanceProfileSection'
import SubscribeSection from './SubscribeSection'

import Styles from './index.scss'

const ProfileDetail = props => (
  <div className="page-content">
    {props.isLoading && <Loading />}
    <Breadcrumb data={props} />
    <div>
      <div className={Styles.headerWrapper}>
        <h1 className="page-title">
          <small>
            <strong>Profile Name:</strong> {props.profileName}
          </small>
        </h1>
        <button
          className={Styles.btnSuperUser}
          onClick={props.goesTopPlatform(props.profileId, props.users[0].email)}
        >
          View as Super User
        </button>
      </div>
      <div className="row margin-bottom-20">
        {!!props.content.length && (
          <div className="col-lg-12 col-md-12">
            <Content title="Profile" data={props.content} />
          </div>
        )}
        <div className="col-lg-12 col-md-12">
          <SubscribeSection />
        </div>
        {props.financeProfile.length && (
          <div className="col-lg-12 col-md-12">
            <FinanceProfileSection
              action={
                props.financeStatus === props.financePendingValue
                  ? props.handleActionFinance
                  : null
              }
              actionOnChange={
                props.financeStatus === props.financePendingValue
                  ? props.handleOnChangeOption
                  : null
              }
              actionOnChangeReason={
                props.financeStatus === props.financePendingValue
                  ? props.handleOnChangeReason
                  : null
              }
              actionParam={
                props.financeStatus === props.financePendingValue
                  ? {
                    id: props.financeProfileId,
                    approvedValue: props.financeApprovedValue,
                    rejectedValue: props.financeRejectedValue,
                    orderId: props.id,
                    selectedValue: props.selectedOption,
                    selectedReason: props.selectedReason,
                  }
                  : null
              }
              reference={props.rejectReasonRef}
            />
          </div>
        )}
        {!!props.profilesBankInformation.length && (
          <div className="col-lg-12 col-md-12">
            <Content
              title="Profiles Bank Information"
              data={props.profilesBankInformation}
            />
          </div>
        )}
      </div>
      <div className="row margin-bottom-20">
        <div className="col-md-12">
          <div className="portlet light portlet-fit">
            <div className="portlet-title">
              <h4>List of Users in this Profile</h4>
            </div>
            <div className="portlet-body">
              <div className="table-scrollable table-scrollable-borderless">
                <table className="table table-hover table-light">
                  <thead>
                    <tr className="uppercase">
                      <th> # </th>
                      <th> Created at </th>
                      <th> Name </th>
                      <th> Email </th>
                      <th> Phone Number </th>
                      <th> Source </th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.users.length &&
                      props.users.map((user, key) => (
                        <Item indexKey={key} key={user.id} user={user} />
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row margin-bottom-20">
        <div className="col-md-12">
          <div className="portlet light portlet-fit">
            <div className="portlet-title">
              <h4>List of Service Card</h4>
            </div>
            <div className="portlet-body">
              <div className="table-scrollable table-scrollable-borderless">
                <table className="table table-hover table-light">
                  <thead>
                    <tr className="uppercase">
                      <th> # </th>
                      <th>
                        {' '}
                        <SortCreatedServiceCard />{' '}
                      </th>
                      <th>
                        {' '}
                        <SortUpdatedServiceCard />{' '}
                      </th>
                      <th> Service card name </th>
                      <th> Type & Category </th>
                      <th> Eligibility </th>
                      <th> Publish Status </th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.productsProfile.rows.length &&
                      props.productsProfile.rows.map((product, key) => (
                        <ItemServiceCard
                          indexKey={key}
                          key={product.id}
                          product={product}
                          skip={props.productsProfile.qs.skip}
                        />
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="portlet-footer">
              {props.productsProfile.totalPages > 1 && (
                <ReactPaginate
                  previousLabel={'previous'}
                  nextLabel={'next'}
                  breakLabel={<a href="">...</a>}
                  breakClassName={'break-me'}
                  pageCount={props.productsProfile.totalPages}
                  marginPagesDisplayed={3}
                  pageRangeDisplayed={2}
                  onPageChange={props.handleOnChangePageServiceCard(
                    props.sortProducts,
                    props.profileId,
                  )}
                  containerClassName={'pagination'}
                  subContainerClassName={'pages pagination'}
                  activeClassName={'active'}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="row margin-bottom-20">
        <div className="col-md-12">
          <div className="portlet light portlet-fit">
            <div className="portlet-title">
              <h4>List of Projects</h4>
            </div>
            <div className="portlet-body">
              <div className="table-scrollable table-scrollable-borderless">
                <table className="table table-hover table-light">
                  <thead>
                    <tr className="uppercase">
                      <th> # </th>
                      <th>
                        {' '}
                        <SortCreatedProjects />{' '}
                      </th>
                      <th>
                        {' '}
                        <SortUpdatedProjects />{' '}
                      </th>
                      <th> Project name </th>
                      <th>
                        {' '}
                        <FilterProjectStatus />{' '}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.projectsProfile.rows.length &&
                      props.projectsProfile.rows.map((project, key) => (
                        <ItemProject
                          indexKey={key}
                          key={project.id}
                          project={project}
                          skip={props.projectsProfile.qs.skip}
                          orderStatus={props.orderStatus}
                        />
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="portlet-footer">
              {props.projectsProfile.totalPages > 1 && (
                <ReactPaginate
                  previousLabel={'previous'}
                  nextLabel={'next'}
                  breakLabel={<a href="">...</a>}
                  breakClassName={'break-me'}
                  pageCount={props.projectsProfile.totalPages}
                  marginPagesDisplayed={3}
                  pageRangeDisplayed={2}
                  onPageChange={props.handleOnChangePageProjects(
                    props.sortProjects,
                    props.filterProjects,
                    props.profileId,
                  )}
                  containerClassName={'pagination'}
                  subContainerClassName={'pages pagination'}
                  activeClassName={'active'}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

ProfileDetail.defaultProps = {
  isLoading: false,
  selectedOption: -1,
  selectedReason: -1,
}

ProfileDetail.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      email: PropTypes.string,
    }),
  ).isRequired,
  isLoading: PropTypes.bool,
  profileName: PropTypes.string.isRequired,
  content: PropTypes.arrayOf(PropTypes.array).isRequired,
  financeProfile: PropTypes.arrayOf(PropTypes.array).isRequired,
  profilesBankInformation: PropTypes.arrayOf(PropTypes.array).isRequired,
  productsProfile: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    totalPages: PropTypes.number.isRequired,
  }).isRequired,
  projectsProfile: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    totalPages: PropTypes.number.isRequired,
  }).isRequired,
  orderStatus: PropTypes.arrayOf(PropTypes.string).isRequired,
  sortProducts: PropTypes.shape({}).isRequired,
  id: PropTypes.string.isRequired,
  profileId: PropTypes.string.isRequired,
  handleActionFinance: PropTypes.func.isRequired,
  handleOnChangeOption: PropTypes.func.isRequired,
  handleOnChangeReason: PropTypes.func.isRequired,
  handleOnChangePageServiceCard: PropTypes.func.isRequired,
  financeProfileId: PropTypes.string.isRequired,
  financeStatus: PropTypes.number.isRequired,
  financePendingValue: PropTypes.number.isRequired,
  financeApprovedValue: PropTypes.number.isRequired,
  financeRejectedValue: PropTypes.number.isRequired,
  rejectReasonRef: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedOption: PropTypes.number,
  selectedReason: PropTypes.number,
  handleOnChangePageProjects: PropTypes.func.isRequired,
  sortProjects: PropTypes.shape({}).isRequired,
  filterProjects: PropTypes.shape({}).isRequired,
  goesTopPlatform: PropTypes.func.isRequired,
}

export default ProfileDetail
